import React, { Component } from 'react';

import './loader.css';
import Plane from "./Plane";
import Chase from "./Chase";
import Bounce from "./Bounce";
import Wave from "./Wave";
import Pulse from "./Pulse";
import Flow from "./Flow";
import Swing from "./Swing";
import Circle from "./Circle";
import CircleFade from "./CircleFade";
import Grid from "./Grid";
import Fold from "./Fold";
import Wander from "./Wander";

class Loading extends Component {

    constructor(props) {
        super(props);
        this.props=props;
    }

    render() {
        const getLoader = (type) => {
            switch (type) {
                case "Plane":   return  <Plane />;
                case "Chase":   return <Chase />;
                case "Bounce":  return  <Bounce />;
                case "Wave":    return  <Wave />;
                case "Pulse":   return  <Pulse />;
                case "Flow":    return  <Flow />;
                case "Swing":   return  <Swing />;
                case "Circle":  return  <Circle />;
                case "CircleFade":  return  <CircleFade />;
                case "Grid":    return  <Grid />;
                case "Fold":    return  <Fold />;
                case "Wander":  return  <Wander />;
                default:        return  <Pulse />;
            }
        }

        return (
            <div className="sk-container">{ getLoader(this.props.type) }</div>
        )
    }
}

export default Loading;
